import Vue from 'vue'
import Vuex from 'vuex'
import xhrModule from './modules/xhrModule.js'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		status: '',
		auth: false,
		user: {
			roles: {},
			project: {}
		},
		freshdeskid: null
	},
	mutations: {
		auth_request (state) {
			state.status = 'loading'
		},
		auth_success (state, user, auth) {
			state.status = 'success'
			state.user = user
			state.auth = true

			// set user email in freshdesk
			if (window.FreshworksWidget) {
				window.FreshworksWidget('prefill', 'ticketForm', {
					email: user.username
				})
			}
		},
		auth_error (state) {
			state.status = 'error'
		},
		logout (state) {
			state.status = ''
			state.auth = false
		},
		freshdesk_success (state, freshdeskid) {
			state.freshdeskid = freshdeskid
		}
	},
	actions: {
		setAuth ({ commit }, user) {
			commit('auth_success', user, true)
		},

		setFreshdeskId ({ commit }, freshdeskid) {
			commit('freshdesk_success', freshdeskid)
		},

		login ({ commit }, user) {
			return new Promise((resolve, reject) => {
				commit('auth_request')

				var url = '/cms/api/session'
				xhrModule.post(url, user, function (data) {
					data = data.data
					if (data.user.username === 'unauthenticated') {
						// failed
						commit('auth_error')
						reject('auth_error')
					} else {
						// log in succeeded
						var user = data.user
						user['privileges'] = data.privileges
						user['project'] = data.project
						commit('auth_success', user, true)
						resolve(data)
					}
				})
			})
		},

		logout ({ commit }) {
			return new Promise((resolve, reject) => {
				var user = {
					'username': 'unauthenticated',
					'password': ''
				}
				user = JSON.stringify(user)

				var url = '/cms/api/session'
				xhrModule.post(url, user, function (data) {
					commit('logout')
					resolve(data)
				})
			})
		},

		setLoggedOut ({ commit }) {
			// used when we do not need to notify the server our user has logged out
			// happens when our session has expired and the server already logged the user out
			return new Promise((resolve, reject) => {
				commit('logout')
				resolve()
			})
		}
	},
	getters: {
		isLoggedIn: state => state.status,
		authStatus: state => state.auth,
		privileges: state => state.user.privileges,
		roles: state => state.user.roles,
		project: state => state.user.project,
		username: state => state.user.username,
		freshdeskid: state => state.freshdeskid
	}
})
